export class AppConsts {
    static remoteServiceBaseUrl: string;
    static appBaseUrl: string;
    static appBaseHref: string; // returns angular's base-href parameter value if used during the publish

    static localeMappings: any = [];

    static readonly userManagement = {
        defaultAdminUserName: 'admin',
    };

    static readonly localization = {
        defaultLocalizationSourceName: 'Coopernico',
    };

    static readonly authorization = {
        encryptedAuthTokenName: 'enc_auth_token',
    };

    static readonly fileSizeLimits = {
        video: 1500 * 1024 * 1024, // 1.5GB,
        image: 10 * 1024 * 1024, // 10MB
        document: 5 * 1024 * 1024, // 5MB,
    };

    static readonly facebookPageLink = 'https://www.facebook.com/icn.italia.consulting.network';
    static readonly linkedinPageLink = 'https://www.linkedin.com/company/icn-italia-consulting-network';
    static readonly fondoSviluppoLink = 'https://www.fondosviluppo.it/';
    static readonly confCooperativeLink = 'https://www.confcooperative.it/';
    static readonly icnLink = 'https://icn.coop/';
    static readonly nodeLink = 'https://node.coop/';
    static readonly cibaLink = 'https://www.cibabrokers.it/';
    static readonly assimocoLink = 'https://www.assimoco.it/';
    static readonly coopSaluteLink = 'https://www.cooperazionesalute.it/';
    static readonly powerEnergiaLink = 'https://www.powerenergia.eu/';
    static readonly conformeLink = 'https://conformesrl.it/';
    static readonly vvaLink = 'https://vvabc.it/';
    static readonly analisiLink = 'https://www.analisi.it/';
    static readonly foncoopLink = 'https://www.foncoop.coop/';
    static readonly termsAndConditionsLink = 'https://www.iubenda.com/termini-e-condizioni/42151639';
    static readonly privacyPolicyLink = 'https://www.iubenda.com/privacy-policy/42151639';
}
